import { create } from 'zustand';
import type { StaffClaims } from './claims';

export type AuthStatus = 'loading' | 'signedOut' | 'noAccess' | 'signedIn';

export interface StaffSession {
  uid: string;
  email: string | null;
  claims: StaffClaims;
}

interface AuthState {
  status: AuthStatus;
  session: StaffSession | null;
  /** A message to show on the sign-in screen after a terminal session event. */
  signInNotice: string | null;
  setLoading: () => void;
  setSignedIn: (session: StaffSession) => void;
  setNoAccess: (session: StaffSession) => void;
  setSignedOut: (notice?: string | null) => void;
  clearNotice: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'loading',
  session: null,
  signInNotice: null,
  setLoading: () => set({ status: 'loading' }),
  setSignedIn: (session) => set({ status: 'signedIn', session }),
  setNoAccess: (session) => set({ status: 'noAccess', session }),
  setSignedOut: (notice = null) =>
    set({ status: 'signedOut', session: null, signInNotice: notice }),
  clearNotice: () => set({ signInNotice: null }),
}));
